import React from 'react';
import {
  Box,
  Typography,
  Tooltip,
  Paper,
  Button,
  useMediaQuery,
  Chip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import { useNavigate } from 'react-router-dom';

function VolumeItem({ title, abstract_url, price, ad = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handlePurchase = () => {
    const queryTitle = encodeURIComponent(title);
    const queryPrice = encodeURIComponent(price);
    navigate(`/purchase?title=${queryTitle}&price=${queryPrice}`);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {/* "New" tag */}
      {ad && isMobile && (
        <Chip
          label="New"
          size="small"
          color="error"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            fontSize: '11px',
            fontWeight: 'bold',
          }}
        />
      )}

      <Paper
        elevation={2}
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'flex-start' : 'center',
          px: 2,
          py: 2,
          mb: 2,
          borderRadius: 2,
          backgroundColor: '#fff',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        {/* Title */}
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight={500}
            sx={{
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              mb: isMobile ? 1.5 : 0,
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Buttons */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: isMobile ? 'center' : 'flex-end',
            gap: 1,
            width: isMobile ? '100%' : 'auto',
            mt: isMobile ? 1 : 0,
          }}
        >
          {/* Abstract */}
          <Tooltip title="View Abstract">
            <Box
              component="a"
              href={abstract_url}
              // target="_blank"
              // target="_blank"
              sx={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                px: 1.5,
                py: 0.5,
                backgroundColor: 'green',
                color: 'white',
                borderRadius: '16px',
                fontSize: '13px',
                fontWeight: 500,
                transition: '0.2s ease',
                '&:hover': {
                  backgroundColor: '#dcedc8',
                },
              }}
            >
              <DownloadIcon sx={{ fontSize: 16, mr: 0.5 }} />
              View Abstract
            </Box>
          </Tooltip>

          {/* Purchase */}
          <Button
            variant="contained"
            size="small"
            startIcon={<ShoppingCartCheckoutIcon />}
            onClick={handlePurchase}
            sx={{
              textTransform: 'none',
              fontSize: '13px',
              fontWeight: 500,
              backgroundColor: '#1a237e',
              '&:hover': {
                backgroundColor: '#0d1542',
              },
              borderRadius: '16px',
              px: 2,
            }}
          >
            Purchase for ₦{price}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default VolumeItem;
